import { ApplicationNames } from './shared';
import envConfig from '../config/config';

const X_ROLES = ['sundial-role:PIXEL_RAD_USER'];

export const pixelRadApplication = {
  name: ApplicationNames.PIXEL_RAD,
  url: envConfig.apps.pixelRad,
  roles: X_ROLES,
};
